<template>
  <v-row dense class="align-center">
    <v-col>
      <tag-display :editable="editable" :event="event" @remove="onRemoveTag" />
    </v-col>
  </v-row>
</template>

<script>
import TagDisplay from './TagDisplay';

export default {
  name: 'GalleryViewHeader',
  components: {
    TagDisplay,
  },
  props: {
    editable: Boolean,
    event: Object,
  },
  methods: {
    onRemoveTag(tag) {
      const newTags = this.event.tags.filter(t => !this._.isEqual(t, tag));
      this.$emit('updateEvent', { tags: newTags });
    },
  },
};
</script>
